import { defineComponent as _defineComponent } from 'vue'
import type { TrackingProviderPropertiesInterface } from '@/helpers/tracking/providers';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleDetailSeason, TitleDetail } from '@/interfaces/title-details-graphql';
import type { SimilarTitleFragment } from '@/components/graphql/queries/GetSimilarTitles.query';
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';

import HorizontalTitleList from '@/components/timeline/HorizontalTitleList.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { ImpressionTrackingEvents } from '@/enums/events';

import { computed, watch } from 'vue';

interface SimilarTitlesProps {
	titles: SimilarTitleFragment[];
	title: NonNullable<TitleDetail | TitleDetailSeason['show']>;
	sponsoredAd?: SponsoredAdFragment | undefined;
	additionalContexts?: SnowplowContext[];
	impressionTrackingLabel?: string;
	impressionTrackingProperty?: string; // @todo problems with enum types - ImpressionTrackingEvents | '';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeadlinedTitleList',
  props: {
    titles: null,
    title: null,
    sponsoredAd: { default: undefined },
    additionalContexts: { default: () => [] },
    impressionTrackingLabel: { default: '' },
    impressionTrackingProperty: { default: '' }
  },
  setup(__props: any) {

const props = __props as { titles: SimilarTitleFragment[], title: NonNullable<TitleDetail | TitleDetailSeason['show']>, sponsoredAd: SponsoredAdFragment | undefined, additionalContexts: SnowplowContext[], impressionTrackingLabel: string, impressionTrackingProperty: string };



watch(
	() => props.title.id,
	(newTitleId, oldTitleId) => {
		if (process.client && newTitleId !== oldTitleId) {
			trackSimilarTitlesLoaded();
		}
	}
);

const moduleGroup = computed(() => [props.impressionTrackingLabel, props.impressionTrackingProperty].join('-'));

// Note(valerio.mazza): SSR special case we need to track the Event during setup
if (process.server && props.titles?.length) {
	trackSimilarTitlesLoaded();
}

function trackSimilarTitlesLoaded() {
	const properties: TrackingProviderPropertiesInterface = {
		action: 'loaded',
		nonInteraction: true,
		label: props.impressionTrackingLabel ?? undefined,
	};
	TrackingHelper.trackEvent(ImpressionTrackingEvents.SIMILAR_TITLES, properties, props.additionalContexts);
}

function trackSimilarTitlesClicked({ index, title }: { index: number; title: SimilarTitleFragment }) {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'title_clicked',
		label: `${props.title.id},${title.id ?? ''}`,
		value: index,
		property: props.impressionTrackingProperty ?? ImpressionTrackingEvents.SIMILAR_TITLES,
	});
}

function trackScroll(label: string) {
	const properties: TrackingProviderPropertiesInterface = {
		label,
		action: 'horizontal_scroller_clicked',
		property: props.impressionTrackingLabel ?? undefined,
	};
	TrackingHelper.trackEvent('userinteraction', properties, props.additionalContexts);
}

return { __sfc: true,props, moduleGroup, trackSimilarTitlesLoaded, trackSimilarTitlesClicked, trackScroll, HorizontalTitleList }
}

})